
import { Injectable, inject } from '@angular/core';
import { HttpService } from 'eas-core-lib';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContactDataService {
  private http = inject(HttpService);

  protected get armApiUrl() {
    return environment.armApiEndpoint;
  }
  protected get mdmApiUrl() {
    return environment.mdmApiEndpoint;
  }
  public get contactInfoLink() {
    return environment.contactInfoLink;
  }

  //armapiUrl() {
  //  return `https://edu-dev-arm-admin.azurewebsites.net`;
  //}
  //mdmapiUrl() {
  //  return `https://edu-dev-eas-mdm-api.azurewebsites.net`;
  //}

  decodeToken(token) {
    var tokenencode = encodeURI(token);
    return this.http.get(
      `${this.armApiUrl}/api/v1/ContactVerification?oneTimeToken=${tokenencode}`
    );
  }
  gethomeEmailRequired() {
    return this.http.get(
      `${this.armApiUrl}/api/v1/ContactVerification/homeEmailAddressRequirement`
    );
  }

  getMDMPersonDtls(uuid, articles) {
    var articlestr = "";
    var i = 0;
    articles.forEach(function (value) {
      if (i > 0) {
        articlestr = articlestr + "&Articles=" + value;
      }
      else {
        articlestr = articlestr + "Articles=" + value;
      }
      i++;
    });
    return this.http.get(
      `${this.mdmApiUrl}/api/v2/Persons/uuid/${uuid}?${articlestr}&sync=true`
    );
  }
  getOrgDtls(orgids) {
    var articlestr = "Articles=IdentifierList";
    return this.http.get(
      `${this.mdmApiUrl}/api/v2/Organizations/${orgids}?${articlestr}`
    );
  }
  getOrgRoles() {
    return this.http.get(
      `${this.mdmApiUrl}/api/v3/OedsPersons/roles`
    );
  }
  getStatesList() {
    return this.http.get(
      `${this.mdmApiUrl}/api/v2/References/states`
    );
  }
  getPhoneypesList() {
    return this.http.get(
      `${this.mdmApiUrl}/api/v2/References/phonetypes`
    );
  }
  updateContactverificationDate(formData) {
    return this.http.put(`${this.armApiUrl}/api/v1/Oeds/PersonOaks`, formData);

  }
  updatePersonContactDtls(oedsPersonRequest) {    
    return this.http.put(`${this.armApiUrl}/api/v1/Oeds/Person`, oedsPersonRequest);
    //return this.http.put('https://localhost:7007/api/v1/Oeds/Person', oedsPersonRequest);
  }
  syncDataToMdm(uuid) {
    return this.http.get(
      `${this.mdmApiUrl}/api/v2/Sync/person/${uuid}`
    );
  }
  sendEmail(emailList) {
    return this.http.post(`${this.armApiUrl}/api/v1/Email`, emailList);
    //return this.http.post('https://localhost:7007/api/v1/Email', emailList);
  }
}
